import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";

interface AlertOpenQuoteProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  isError?: any;
  setIsValid?: any;
  setAlertModelShow?: any;
  setShow?:any;
  // submitHandler?: () => void;
}

const AlertOpenQuote: React.FC<AlertOpenQuoteProps> = ({
  open,
  title,
  onHide = () => {},
  content,
  setIsValid,
  isError,setAlertModelShow,setShow
  // submitHandler = () => {}
}) => {
  const classes = useStyles();

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm"); // Adjust the type definition

  const submitHandler = () => {
    // onHide();
    setAlertModelShow(false);
    setShow(true);
  };
  const closeModel =() =>{
    setAlertModelShow(false);
  }
  return (
    <Popup
      open={open}
      title={title || ""}
      onHide={onHide}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          {isError ? (
            <CustomButton variant="outlined" title="Close" onClick={onHide} />
          ) : (
            <>
              <CustomButton variant="outlined" title="Cancel" onClick={closeModel} />
              <CustomButton title="Continue" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Some customer details, such as addresses and property information, are incomplete because the survey was skipped. Please ensure all required details are filled in to generate an accurate quote. Incomplete information may lead to errors or delays in processing.
            </Alert>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertOpenQuote;
